import React from 'react';
import {get} from 'lodash';
import {BlockControls} from '../block-controls';
import {Button} from '@app/common';

export const renderInactiveHandover = (
    handover,
    index,
    fields,
    removeBlock,
    activateBlock,
) => {
    const text = get(handover, 'text', '');
    const CTA = get(handover, 'call_to_action');
    return (
        <div className="kare-block-wrapper kare-handover-block">
            <section className="kare-block kare-block--inactive kare-block-choice">
                <h1>{text}</h1>
                <Button
                    outlinedPrimary={true}
                    onClick={(e) => {
                        e.preventDefault();
                    }}
                >
                    {CTA}
                </Button>
            </section>
            {index >= 0 && fields && removeBlock && activateBlock && (
                <BlockControls
                    index={index}
                    fields={fields}
                    removeBlock={removeBlock}
                    activateBlock={activateBlock}
                />
            )}
        </div>
    );
};

export const HandoverBlockField = (props) => {
    const {removeBlock, index, fields} = props;

    const handover = get(props, ['input', 'value', 'handover_block'], '');

    return renderInactiveHandover(
        handover,
        index,
        fields,
        removeBlock,
        props.activateBlock,
    );
};
